// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2374":"4b610050499239cf","3877":"fe336940f98fdfab","6272":"aa4472f7082b94cd","6355":"893de9d4bc8ced88"}[chunkId] + ".css";
};